import React from 'react';
import { Navigation } from '../components/Navigation';
import { HeroSection } from '../components/HeroSection';
import { FeaturesSlider } from '../components/FeaturesSlider';
import { PageCards } from '../components/PageCards';
import { ReviewsCarousel } from '../components/ReviewsCarousel';
import { GoogleReviewsSection } from '../components/GoogleReviewsSection';
import { ContactSection } from '../components/ContactSection';
import { Footer } from '../components/Footer';

const HomePage = () => {
  return (
    <div className="min-h-screen">
      <Navigation />
      <HeroSection />
      <FeaturesSlider />
      <PageCards />
      <ReviewsCarousel />
      <GoogleReviewsSection />
      <ContactSection />
      <Footer />
    </div>
  );
};

export default HomePage;
